<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.path" />
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title" /> -->
  </div>
</template>

<script>
export default {
  mounted() {

  }
};
</script>

<style>
.translate-child{
    position: absolute;
    left: 0;
    top: 30px;
    width: 100%;
    font-size: 16px;
}
.translate-parent{
    position: relative;
}
</style>
